// extracted by mini-css-extract-plugin
export default {"wrapper":"BlogSameAuthor_wrapper__t0GpZ","heading":"BlogSameAuthor_heading__8OnfP","list":"BlogSameAuthor_list__lJgIi","noBlogSameAuthor":"BlogSameAuthor_noBlogSameAuthor__iJxus"};